<template>
    <transition name="layout-fade">
        <Loader v-if="loading" style="max-width: 100%"/>
        <v-layout wrap>
            <Navigation/>
            <v-slide-y-transition mode="out-in">
                <router-view/>
            </v-slide-y-transition>
        </v-layout>
    </transition>
</template>

<script>
    import Order from '../../../../api/order'
    import Loader from '../../../../components/Loader/Layout'
    import Navigation from './NavigationInProgress'

    export default {
        name: 'orderLayoutInProgress',
        components: {Navigation, Loader},
        data: () => ({
            loading: false
        }),
        created () {
            this.loading = true

            Order
                .getAllInProgress()
                .then(response => this.$store.commit('storeInProgressOrders', response.data.data))
                .catch(error => new Error(error))
                .finally(() => this.loading = false)
        },
    }
</script>
